import PhoneNumber from './PhoneNumber'
export default PhoneNumber
